<div class="operations-panel">
  <div class="operations-panel__header">
    <div class="operations-panel__header-status">
      @if (inProgressCount() > 0) {
        <sim-spinner class="operations-panel__header-spinner" buttonSpinner />
        <span class="operations-panel__title" i18n="@@OPERATIONS_IN_PROGRESS"
          >{{ inProgressCount() }} operations in progress</span
        >
      } @else if (errorCount() > 0) {
        <sim-icon icon="error_outline" [sizeInPx]="24" color="var(--danger)" />
        <span class="operations-panel__title" i18n="@@OPERATIONS_TASKS_FAILED">{{ errorCount() }} Task failed</span>
      } @else {
        <span class="operations-panel__title" i18n="@@OPERATIONS_IN_PROGRESS_TITLE">Operations in progress</span>
      }
    </div>

    <div class="operations-panel__header-actions">
      @if (inProgressCount() === 0 && errorCount() > 0) {
        <button sim-stroked-button simColor="secondary" type="button" (click)="clearErrors()">
          <ng-container i18n="@@OPERATIONS_CLEAR_WARNING">Clear warning message</ng-container>
        </button>
      }
      <button sim-icon-button class="edit-panel__close" type="button" (click)="close()">
        <sim-icon icon="close2" [sizeInPx]="24" color="#313844" />
      </button>
    </div>
  </div>

  <div class="operations-panel__list">
    @for (operation of operations(); track operation.id) {
      @if (operation.state === 'ERROR') {
        <div class="operations-panel__item operations-panel__item--error">
          <sim-icon class="operations-panel__item-icon" icon="error_outline" [sizeInPx]="24" color="var(--danger)" />
          <span class="operations-panel__item-error" [title]="operation.error">{{ operation.error }}</span>
          @if (operation.retry) {
            <button
              sim-icon-button
              type="button"
              (click)="retry(operation.id)"
              i18n-aria-label="@@OPERATIONS_IN_PROGRESS_RETRY"
              aria-label="Retry operation"
            >
              <sim-icon icon="refresh" [sizeInPx]="20" />
            </button>
          }
          <button sim-icon-button class="edit-panel__close" type="button" (click)="remove(operation.id)">
            <sim-icon icon="close2" [sizeInPx]="24" color="#313844" />
          </button>
        </div>
      } @else {
        <div class="operations-panel__item">
          <sim-icon
            class="operations-panel__item-icon"
            [icon]="operationIcon(operation)"
            [sizeInPx]="30"
            color="var(--text-icon-lighter)"
          />
          <div class="operations-panel__item-content">
            <span class="operations-panel__item-name" [title]="operation.name">{{ operation.name }}</span>
            <div class="operations-panel__item-row">
              <sim-progress-bar
                class="operations-panel__item-bar"
                [barValue]="operation.progress"
                [barMaxValue]="100"
                [barHeight]="8"
                hideDangerRange
              />
              @if (operation.stagesTotal) {
                <span class="operations-panel__item-progress"
                  >{{ operation.stagesDone }}/{{ operation.stagesTotal }}</span
                >
              } @else {
                <span class="operations-panel__item-progress">{{ operation.progress }}%</span>
              }
              <button sim-icon-button class="operations-panel__close" type="button" (click)="remove(operation.id)">
                <sim-icon icon="close2" [sizeInPx]="14" color="#313844" />
              </button>
            </div>
          </div>
        </div>
      }
    } @empty {
      <div class="operations-panel__empty" i18n="@@OPERATIONS_IN_PROGRESS_EMPTY">No operations in progress</div>
    }
  </div>
</div>
